import { render } from "./HelpCategory.vue?vue&type=template&id=4f91bad8"
import script from "./HelpCategory.vue?vue&type=script&lang=js"
export * from "./HelpCategory.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__